import { updateState } from '@ardoq/common-helpers';
import { reducedStream, reducer } from '@ardoq/rxbeach';
import {
  dragCompleted,
  dragEnteredDropZone,
  dragExitedDropZone,
  dragInitiated,
} from '../actions';

export type DragState = {
  isDragging: boolean;
  hoveredDropZoneIds: string[];
};

const addDropZoneId = (state: DragState, dropZoneId: string): DragState => ({
  ...state,
  hoveredDropZoneIds: [...state.hoveredDropZoneIds, dropZoneId],
});

const removeDropZoneId = (state: DragState, dropZoneId: string): DragState => ({
  ...state,
  hoveredDropZoneIds: state.hoveredDropZoneIds.filter(id => id !== dropZoneId),
});

export const dragState$ = reducedStream<DragState>(
  'dragState$',
  {
    isDragging: false,
    hoveredDropZoneIds: [],
  },
  [
    reducer(dragInitiated, updateState({ isDragging: true })),
    reducer(
      dragCompleted,
      updateState({ isDragging: false, hoveredDropZoneIds: [] })
    ),
    reducer(dragEnteredDropZone, addDropZoneId),
    reducer(dragExitedDropZone, removeDropZoneId),
  ]
);
